import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

// import Moment from "react-moment";

import DEMO from '../store/constant';
import PropTypes from 'prop-types';

import { upload } from '../lib/MyHttp';

class Forms extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    /**
     * 기본 데이터 변경시
     * @param  e
     */
    onChange = e => {
        const file = e.target.files[0];
        if (file === undefined) return;

        upload(this, this.props.upload_type, file, this.resultUpload);
    };

    /**
     * 파일업로드
     */
    resultUpload = response => {
        // "etag":"\"b67fde649cf7f6b2eab66a855c4377d2\"",
        // "location":"https://d1kxvxsz0nulrt.cloudfront.net/resource/dev/banner/image/ae2f6d98-a971-4085-abde-78ca173c5dc7.jpeg",
        // "name":"ae2f6d98-a971-4085-abde-78ca173c5dc7.jpeg",
        // "fieldname":"file",
        // "originalname":"풍경2.jpeg",
        // "encoding":"7bit",
        // "mimetype":"image/jpeg",
        // "size":4681

        if (this.props.onChange) {
            this.props.onChange(response.location);
        }
    };

    /**
     * 파일명 삭제
     * @param {*} name
     */
    delName = name => {
        this.props.onChange('');
    };

    render() {
        let btn = '';
        if (this.props.btn_name !== '') {
            btn = (
                <InputGroup.Append>
                    <Button onClick={this.props.btn_event}>{this.props.btn_name}</Button>
                </InputGroup.Append>
            );
        }

        var fileSplit = this.props.value.split(',');

        return (
            <Form.Group>
                <Form.Label>
                    {this.props.title}
                    <small> &nbsp;&nbsp; (클릭 다운로드)</small>
                </Form.Label>

                {this.props.value.length > 0 ? (
                    <InputGroup className="mb-3">
                        {fileSplit.map(
                            src =>
                                src !== '' &&
                                (this.props.show_name ? (
                                    <div style={{ display: 'flex', flexDirection: 'row', height: 40 }}>
                                        <a href={src} target={DEMO.BLANK_LINK}>
                                            <InputGroup className="mb-3">
                                                <Form.Control type={'text'} value={src} disabled={true} />
                                            </InputGroup>
                                        </a>
                                        <Button
                                            variant="outline-danger"
                                            onClick={e => {
                                                this.delName(src);
                                            }}
                                        >
                                            삭제
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <a href={src} target={DEMO.BLANK_LINK}>
                                            <img src={src} alt="이미지" width={this.props.img_width} height={this.props.img_height} />
                                        </a>
                                        <Button
                                            variant="outline-danger"
                                            onClick={e => {
                                                this.delName(src);
                                            }}
                                        >
                                            삭제
                                        </Button>
                                    </div>
                                )),
                        )}
                    </InputGroup>
                ) : this.props.disabled ? (
                    <InputGroup className="mb-3">
                        <Form.Control type={'text'} value={'등록 파일 없음'} disabled={true} />
                    </InputGroup>
                ) : (
                    ''
                )}

                {!this.props.disabled && (
                    <InputGroup className="mb-3">
                        <Form.Control type={this.props.type} placeholder={this.props.placeholder} onChange={this.onChange} disabled={this.props.disabled} />
                        {btn}
                    </InputGroup>
                )}
            </Form.Group>
        );
    }
}

Forms.defaultProps = {
    title: '',
    type: 'file',
    value: '',
    placeholder: '',
    disabled: false,
    show_name: false,
    btn_name: '',
    btn_event: undefined,
    img_width: '200',
    img_height: '200',
};

Forms.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
};

export default Forms;
